import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { TransformationSection } from '../components/sales/TransformationSection';
import { SystemSection } from '../components/sales/SystemSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { UseCasesSection } from '../components/sales/UseCasesSection';
import { TimeSavingSection } from '../components/sales/TimeSavingSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { LibrarySection } from '../components/sales/LibrarySection';
import { CheckoutSection } from '../components/sales/CheckoutSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalCtaSection } from '../components/sales/FinalCtaSection';
import { SiteFooter } from '../components/sales/SiteFooter';
import { StickyMobileCta } from '../components/StickyMobileCta';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-234" data-mp="3aljgi87parfc">
      <header className="border-b border-brand-charcoal/10 bg-brand-ivory" data-id="element-235" data-mp="35r6tjo70mxyu">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-236" data-mp="30u6n3c697t77">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-237" data-mp="2vwnbyl4urwjh">
            Makeup Instructor <span className="text-brand-gold" data-id="element-238" data-mp="3ojhsj6yjubro">Ready</span>
          </p>
        </div>
      </header>

      <main data-id="element-239" data-mp="3jkenhmikk5jp">
        <HeroSection data-id="element-240" data-mp="3jk4wbvlsfscf" />
        <InsideSection data-id="element-241" data-mp="3jjdahchzt8zc" />
        <TransformationSection data-id="element-242" data-mp="3jits5uofkiks" />
        <SystemSection data-id="element-243" data-mp="3fitewdd2idfb" />
        <VolumesSection data-id="element-244" data-mp="3fjcmb053djf3" />
        <UseCasesSection data-id="element-245" data-mp="3fi1jb2jh0fp1" />
        <TimeSavingSection data-id="element-246" data-mp="3fkw2yruntwhe" />
        <BonusesSection data-id="element-247" data-mp="284zrom23jjq6" />
        <LibrarySection data-id="element-248" data-mp="285htdy7j2q5h" />
        <CheckoutSection data-id="element-249" data-mp="286syq2gmg5yp" />
        <AudienceSection data-id="element-250" data-mp="282wsbbf20e8s" />
        <FaqSection data-id="element-251" data-mp="2434rxlztdeei" />
        <FinalCtaSection data-id="element-252" data-mp="242l6vweva9w9" />
      </main>

      <SiteFooter data-id="element-253" data-mp="245qypjevrpvo" />
      <StickyMobileCta data-id="element-254" data-mp="25ktls8tx9j6z" />
    </div>;
}